import React from 'react'
import { Field, reduxForm, change as changeFieldValue } from 'redux-form'
import { translate } from 'react-polyglot'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
	Form,
	ButtonGroup,
	Button,
	Avatar,
	FlexContainer,
	Text,
	Icon,
} from 'components'
import { Text as TextField, Email, Switch } from 'components/FormField'
import { required, email } from 'utils/validation'

const ProfileForm = ({
	handleSubmit,
	submitting,
	onHandleChangeTheme,
	onHandleChangeReportSettings,
	error,
	reset,
	t,
	image,
	onUploadImage,
	userImageUploadPending,
	userImageUploadSuccessful,
	...props
}) => (
	<Form onSubmit={handleSubmit} error={error}>
		<FlexContainer
			className="c-form__fieldwrap"
			justifyContent="flex-start"
		>
			<a
				href="#"
				onClick={e => {
					e.preventDefault()

					document.getElementById('user-image-input').click()
				}}
			>
				<Avatar size="large" image={image} />
			</a>
			<Text color="dark">
				<ButtonGroup orientation="horizontal">
					<input
						id="user-image-input"
						type="file"
						accept="image/jpeg,image/png,image/gif,image/svg+xml,image/bmp,image/tiff"
						onChange={onUploadImage}
						className="u-visually-hidden"
					/>
					<Button
						text={t('forms.update_profile_image')}
						size="small"
						layout="ghosted"
						onClick={() => {
							document.getElementById('user-image-input').click()
						}}
						showFeedback
						isLoading={userImageUploadPending}
						wasSuccessful={userImageUploadSuccessful}
						// hasFailed= null,
					/>

					{/* <Button
						icon={<Icon name="delete" />}
						size="small"
					/> */}
				</ButtonGroup>
				<br />
				<small>{t('forms.image_requirements')}</small>
			</Text>
		</FlexContainer>
		<Field
			name="firstName"
			label={t('forms.first_name')}
			component={TextField}
			validate={[required]}
			onChange={async e => {
				await props.changeFieldValue(
					'profile',
					'firstName',
					e.target.value
				)

				handleSubmit()
			}}
			required
		/>
		<Field
			name="lastName"
			label={t('forms.last_name')}
			component={TextField}
			validate={[required]}
			onChange={async e => {
				await props.changeFieldValue(
					'profile',
					'lastName',
					e.target.value
				)

				handleSubmit()
			}}
			required
		/>
		<Field
			name="email"
			label={t('forms.email')}
			component={Email}
			validate={[required, email]}
			disabled
		/>
		<Field
			name="theme"
			label={t('settings.theme')}
			description={t('settings.theme_description')}
			component={Switch}
			onChange={onHandleChangeTheme}
		/>
		<Field
			name="reports"
			label={t('settings.reports')}
			description={t('settings.reports_description')}
			component={Switch}
			onChange={onHandleChangeReportSettings}
		/>
	</Form>
)

const mapDispatchToProps = dispatch =>
	bindActionCreators({ changeFieldValue }, dispatch)

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm(
		{
			form: 'profile',
		},
		mapDispatchToProps
	)(translate()(ProfileForm))
)
